/**
 * @packageDocumentation
 * @module API
 * @category Core
 */
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { LoaderService } from '../loader';

/**
 * Отключение всех лоадеров при возникновении ошибки в запросе.
 *
 * @group Interceptors
 *
 * @param req
 * @param next
 * @returns
 */
export const loaderHttpErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const loaderService = inject(LoaderService);

  return next(req).pipe(
    catchError((error) => {
      loaderService.clearLoadings();
      return throwError(() => error);
    }),
  );
};
